import { Answer } from "models/Answer";
import Question from "models/Question";
import { Tag } from "models/Tag";

export function getSortedActiveQuestions(questions: Question[]): Question[] {
    return [...questions]
        .filter((question) => question.isActive)
        .sort((a, b) => a.order - b.order);
}

export function getFirstOverrideTagForQuestions(
    questions: Question[],
    answers: Answer[],
): Tag | undefined {
    for (const question of getSortedActiveQuestions(questions)) {
        const overrideTag = answers
            .filter(
                (answer) => answer.isActive && answer.questionId === question.id,
            )
            .flatMap((answer) =>
                [...answer.activeTags].sort(
                    (a, b) => (a.order ?? 0) - (b.order ?? 0),
                ),
            )
            .find((tag) => tag.overrideModuleScore === true);

        if (overrideTag) {
            return overrideTag;
        }
    }

    return undefined;
}
